import filter from "@/api/filter";
export const config = {
  data() {
    return {
      columns: []
    };
  },
  mounted() {
    let columns = [
      {
        title: '产品名称',
        minWidth: 200,
        key: 'productName',
        align: 'center',
        render(h, params) {
          return (
            <span>
              {params.row.productName}({params.row.productCode})
            </span>
          );
        }
      },
      {
        title: '保单号',
        key: 'policyNo',
        align: 'center',
        width: 230,
        ellipsis: true,
        tooltip: true
      },
      {
        title: '投/被保险人',
        key: 'holderName',
        align: 'center',
        minWidth: 160,
        tooltip: true,
        render(h, params) {
          if (params.row.insuranceName) {
            const res = params.row.holderName + '/' + params.row.insuranceName;
            return <span>{res}</span>;
          } else {
            const res = params.row.holderName;
            return <span>{res}</span>;
          }
        }
      },
      {
        title: '保单状态',
        key: 'status',
        align: 'center',
        minWidth: 120,
        tooltip: true,
        render(h, params) {
          const m = new Map([
            ['1', '已承保'],
            ['-1', '已退保'],
            ['0', '已终止']
          ]);
          return <span>{m.get(params.row.status + '')}</span>;
        }
      },

      {
        title: '所属团队',
        key: 'groupName',
        align: 'center',
        minWidth: 200,
        render(h, params) {
          const res = params.row.groupName ? params.row.orgName + '/' + params.row.groupName : params.row.orgName;
          return (
            <Tooltip style="width:100%" content={res}>
              <div class="txt-ellipsis2" style="display:block">
                {res}
              </div>
            </Tooltip>
          );
        }
      },
      {
        title: '所属业务员',
        key: 'salesmanName',
        align: 'center',
        minWidth: 160
      },
      
      
      {
        title: '创建时间',
        key: 'createTime',
        align: 'center',
        minWidth: 160,
        tooltip: true,
        render(h, params) {
          const time = filter.filterTime(params.row.createTime, 'YYYY-MM-DD HH:mm');
          return <span>{time}</span>;
        }
      },
      {
        title: '操作',
        slot: 'bar',
        align: 'center',
        width: 160,
        fixed: 'right'
      }
    ];
    this.columns = columns;
  },
  methods: {}
};
